module.exports = __webpack_public_path__ + "img/home_bk.969499c6.png";